import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import { useAuth } from '../context/AuthContext';
import { tenantReturnPath } from '../utils/tenantRouting';

const RSMinCallbackPage = () => {
  const navigate = useNavigate();
  const { loginWithRSMinToken, user } = useAuth();
  const [error, setError] = useState('');
  const [connected, setConnected] = useState(false);
  const startedRef = useRef(false);
  const callbackParams = new URLSearchParams(window.location.search);
  const next = callbackParams.get('next') || '/t/rsmin/harvesting?mode=contribute';
  const returnPath = tenantReturnPath('rsmin', `?${new URLSearchParams({ next })}`);
  const embedded = callbackParams.get('embedded') === '1'
    || new URL(returnPath, window.location.origin).searchParams.get('embedded') === '1';

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    const exchange = async () => {
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');

      if (!token) {
        setError('Missing RSMin token in callback URL.');
        return;
      }

      try {
        await loginWithRSMinToken(token);
        setConnected(true);
      } catch (err) {
        setError(err.response?.data?.message || 'Unable to connect your RSMin account.');
      }
    };

    exchange();
  }, [loginWithRSMinToken, navigate, embedded, returnPath]);

  useEffect(() => {
    if (!connected || !user) return;
    const route = new URL(returnPath, window.location.origin);
    if (embedded) route.searchParams.set('embedded', '1');
    navigate(`${route.pathname}${route.search}${route.hash}`, { replace: true });
  }, [connected, user, embedded, returnPath, navigate]);

  const content = (
    <div className="page auth-page">
      <h2>Connecting RSMIN</h2>
      {error ? <div className="error-msg">{error}</div> : <p>Signing you in...</p>}
    </div>
  );

  return embedded ? content : <MainLayout>{content}</MainLayout>;
};

export default RSMinCallbackPage;
